const JOURNEY_CHIPS = ["Invite teammate", "Create project"];

export default function AfterLoginMock() {
  return (
    <div className="max-w-full overflow-hidden rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
      <p className="text-sm font-semibold text-gray-900">Test account</p>
      <div className="mt-3 space-y-2">
        <div className="flex h-8 items-center rounded-md border border-gray-200 bg-white px-2.5 text-sm text-gray-900">
          you@yourproduct.com
        </div>
        <div className="flex h-8 items-center rounded-md border border-gray-200 bg-white px-2.5 text-sm tracking-widest text-gray-400">
          ••••••••
        </div>
      </div>
      <div className="mt-3 flex flex-wrap gap-2 border-t border-gray-100 pt-3">
        {JOURNEY_CHIPS.map((label) => (
          <span key={label} className="rounded-md bg-primary-50 px-2 py-1 text-xs font-semibold text-primary-700">
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
